/**
 * Sidebar Widgets Script
 *
 * This script manages the movement of sidebar widgets between containers
 * based on screen width.
 *
 * It includes:
 * - Moving widgets between desktop and mobile containers based on screen width.
 * - Handling window resize events to reposition widgets accordingly.
 *
 * This script relies on jQuery.
 */

// Import the mobileNavBreakpoint constant
import { mobileNavBreakpoint as sidebarNavBreakpoint } from '../config/constants';

// jQuery ready function
$(function() {
	
	const $widgetContainerDesktop = $('#pageSidebarWidgetsDesktop');
	const $widgetContainerMobile = $('#pageSidebarWidgetsMobile');
	
	// Move sidebar widgets between desktop and mobile containers based on the current screen width
	const moveSidebarWidgets = () => {
		const windowWidth = $(window).width();
		
		if (windowWidth >= sidebarNavBreakpoint) {
			$widgetContainerMobile.contents().appendTo($widgetContainerDesktop);
		} else {
			$widgetContainerDesktop.contents().appendTo($widgetContainerMobile);
		}
	}

	// Attach the resize event listener to reposition widgets on window resize
	$(window).resize(moveSidebarWidgets);
	
	// Initial call to position the widgets correctly on page load
	moveSidebarWidgets();

});